import { styled } from 'styled-components'
import { ReactComponent as AIPetsIconSVG } from '../../../icons/assets/ai-pets.svg'
import { ReactComponent as AINewbornIconSVG } from '../../../icons/assets/ai-newborn.svg'
import { ReactComponent as AIFamilyIconSVG } from '../../../icons/assets/ai-family.svg'
import { ReactComponent as AIPlacesIconSVG } from '../../../icons/assets/ai-places.svg'
import { ReactComponent as AITravelIconSVG } from '../../../icons/assets/ai-travel.svg'
import { ReactComponent as AIVintagePostersIconSVG } from '../../../icons/assets/ai-vintage-posters.svg'
import { ReactComponent as AIHomeHobbiesPlantIconSVG } from '../../../icons/assets/ai-home-hobbies-plant.svg'
import { ReactComponent as AIHomeHobbiesBowlIconSVG } from '../../../icons/assets/ai-home-hobbies-bowl.svg'
import { ReactComponent as AIHomeHobbiesHouseIconSVG } from '../../../icons/assets/ai-home-hobbies-house.svg'
import { ReactComponent as AIFoodCutleryIconSVG } from '../../../icons/assets/ai-food-cutlery.svg'
import { ReactComponent as AIFoodPlaceSettingIconSVG } from '../../../icons/assets/ai-food-place-setting.svg'
import { ReactComponent as AIFoodPlaceSettingLargeIconSVG } from '../../../icons/assets/ai-food-place-setting-large.svg'
import { ReactComponent as AIFoodPotIconSVG } from '../../../icons/assets/ai-food-pot.svg'
import { ReactComponent as AIFoodWineGlassIconSVG } from '../../../icons/assets/ai-food-wine-glass.svg'
import { ReactComponent as AIFoodRecipeCardIconSVG } from '../../../icons/assets/ai-food-recipe-card.svg'

export const AIPetsIcon = styled(AIPetsIconSVG)`
  width: 32px;
  height: 32px;
`

export const AINewbornIcon = styled(AINewbornIconSVG)`
  width: 32px;
  height: 32px;
`

export const AIFamilyIcon = styled(AIFamilyIconSVG)`
  width: 32px;
  height: 32px;
`

export const AIPlacesIcon = styled(AIPlacesIconSVG)`
  width: 32px;
  height: 32px;
`

export const AITravelIcon = styled(AITravelIconSVG)`
  width: 32px;
  height: 32px;
`

export const AIVintagePostersIcon = styled(AIVintagePostersIconSVG)`
  width: 32px;
  height: 32px;
`

export const AIHomeHobbiesPlantIcon = styled(AIHomeHobbiesPlantIconSVG)`
  width: 32px;
  height: 32px;
`

export const AIHomeHobbiesBowlIcon = styled(AIHomeHobbiesBowlIconSVG)`
  width: 32px;
  height: 32px;
`

export const AIHomeHobbiesHouseIcon = styled(AIHomeHobbiesHouseIconSVG)`
  width: 32px;
  height: 32px;
`

export const AIFoodCutleryIcon = styled(AIFoodCutleryIconSVG)`
  width: 32px;
  height: 32px;
`

export const AIFoodPlaceSettingIcon = styled(AIFoodPlaceSettingIconSVG)`
  width: 32px;
  height: 32px;
`

export const AIFoodPlaceSettingLargeIcon = styled(
  AIFoodPlaceSettingLargeIconSVG
)`
  width: 32px;
  height: 32px;
`

export const AIFoodPotIcon = styled(AIFoodPotIconSVG)`
  width: 32px;
  height: 32px;
`

export const AIFoodWineGlassIcon = styled(AIFoodWineGlassIconSVG)`
  width: 32px;
  height: 32px;
`

export const AIFoodRecipeCardIcon = styled(AIFoodRecipeCardIconSVG)`
  width: 32px;
  height: 32px;
`

export const Container = styled.nav``

export const Section = styled.ul`
  margin-block: 0;
  padding-left: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Item = styled.li`
  list-style-type: none;
  padding: 0;
`
